/* global axios */
import ApiClient from './ApiClient';

class ActivitiesAPI extends ApiClient {
  constructor() {
    super('activities', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(activityData) {
    return axios.post(this.url, { activity: activityData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  timeline(activitableType, activitableId, params = {}) {
    return axios.get(`${this.url}/timeline`, {
      params: {
        activitable_type: activitableType,
        activitable_id: activitableId,
        ...params
      }
    });
  }

  createNote(activitableType, activitableId, content) {
    return axios.post(`${this.url}/create_note`, {
      activitable_type: activitableType,
      activitable_id: activitableId,
      content
    });
  }

  logCall(activitableType, activitableId, content, duration = null) {
    return axios.post(`${this.url}/log_call`, {
      activitable_type: activitableType,
      activitable_id: activitableId,
      content,
      duration
    });
  }
}

export default new ActivitiesAPI();
